// extracted by mini-css-extract-plugin
module.exports = {"section":"sportCards_section__snhuu","pageTitle":"sportCards_pageTitle__g6UcF","loading":"sportCards_loading__qMA5Z"};